import Vector from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { toLonLat } from 'ol/proj';
import { map } from './map';
import { fetchData } from './services';
import { vendorMarker, vendorMarkerStyle, userMarker, userMarkerAccuracy, popupOverlay } from './markers';
import { getCircularAvatar } from './avatar-utils';

require('@babel/polyfill');
require('./router');

let vendorMarkers, vendorDetails, checkins;

function togglePopup(event) {
	const feature = map.forEachFeatureAtPixel(event.pixel, features => features);
	const popup = document.querySelector('.popup');
	const directionsButton = document.querySelector('.popup__button');

	if (feature) {
		const markerId = vendorMarkers.findIndex(marker => marker === feature);

		let vendorId;

		if (checkins[markerId].seller && checkins[markerId].seller.length > 0) {
			vendorId = checkins[markerId].seller[0].id;
		} else {
			vendorId = checkins[markerId].id;
		}

		const vendor = vendorDetails.find(vendorDetail => vendorDetail.id === vendorId);

		if (!vendor) {
			console.error('No vendor found for ID:', vendorId);
			return;
		}

		const vendorNameElement = document.querySelector('.popup__title');
		const shopOpeningElement = document.querySelector('.popup__opening');
		const shopOpenElement = document.querySelector('.popup__open');
		const shopOpeningTime = new Date(vendor.opening).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
		const shopClosingElement = document.querySelector('.popup__closing');
		const shopClosingTime = new Date(vendor.closing).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
		const shopTimeSeperator = document.querySelector('.popup__timeSeperator');
		const validDate = date => date != 'Invalid Date';

		vendorNameElement.innerHTML = vendor.firstName;

		if (shopOpeningTime && validDate(shopOpeningTime)) {
			shopOpeningElement.innerHTML = shopOpeningTime;
		} else {
			shopOpeningElement.innerHTML = '';
		}
		if (shopClosingTime && validDate(shopClosingTime)) {
			shopClosingElement.innerHTML = shopClosingTime;
		} else {
			shopClosingElement.innerHTML = '';
		}

		if (shopOpeningTime && shopClosingTime && validDate(shopOpeningTime) && validDate(shopClosingTime)) {
			shopTimeSeperator.innerHTML = ' · ';
			shopOpenElement.innerHTML = 'Åpent';
		} else {
			shopTimeSeperator.innerHTML = '';
			shopOpenElement.innerHTML = '';
		}

		const coordinates = feature.getGeometry().getCoordinates();
		const destination = toLonLat(coordinates);

		popup.classList.toggle('hidden');

		// open google maps with directions
		directionsButton.addEventListener('click', () =>
			window.open(
				`https://www.google.com/maps/dir/?api=1&destination=${destination[1]},${destination[0]}`
			)
		);

		popupOverlay.setPosition(coordinates);
	}
}

const init = async () => {

	try {
		const cms = await fetchData();

		if (!cms || !cms.data) {
			console.error('❌ No CMS data received');
			return;
		}

		const activeKeys = value => Object.keys(value).length !== 0;
		const activeSellers = entry => {
			if (entry.seller) {
				const isCheckedOut = entry.end !== null;
				const isEnabled = entry.seller.length > 0;
				return !isCheckedOut && isEnabled;
			}
			return false;
		};

		// Get the data
		const avatars = (cms.data.avatars || []).filter(activeKeys);
		const shopCheckins = (cms.data.shopCheckins || []).filter(activeKeys);
		const sellerCheckins = (cms.data.sellerCheckins || []).filter(activeSellers);

		vendorDetails = (cms.data.vendorDetails || []).filter(activeKeys);

		// Use shopCheckins as primary data source (these are your actual shops)
		// Add any active sellerCheckins if they exist
		checkins = [...shopCheckins, ...sellerCheckins];

		if (checkins.length === 0) {
			console.warn('⚠️ No checkins found - no markers will be displayed');
			return;
		}

		console.log('✅ Creating markers...');
		vendorMarkers = checkins.map(vendor => vendorMarker(vendor));

		const getAvatarUrls = checkins.map(checkin => {
			let id, thumbnail;

			// For shop checkins, use the shop ID directly
			if (checkin.id) {
				id = checkin.id;
			}
			// For seller checkins, use the seller ID
			else if (checkin.seller && checkin.seller[0] && checkin.seller[0].id) {
				id = checkin.seller[0].id;
			}

			// Find matching avatar
			const avatar = avatars.find(avatar => avatar.id === id);
			if (avatar && avatar.sellerImage && avatar.sellerImage[0] && avatar.sellerImage[0].thumbnail) {
				thumbnail = avatar.sellerImage[0].thumbnail;
			}

			return thumbnail;
		});

		// set marker thumbnails with circular avatars
		const stylePromises = vendorMarkers.map(async (marker, index) => {
			const url = getAvatarUrls[index];
			if (url) {
				const circularUrl = await getCircularAvatar(url, 50);
				marker.setStyle(vendorMarkerStyle(circularUrl));
			} else {
				marker.setStyle(vendorMarkerStyle());
			}
		});
		
		// Wait for all avatar processing to complete
		await Promise.all(stylePromises);

		// create markers
		const markers = () =>
			new Vector({
				features: [...vendorMarkers, userMarker, userMarkerAccuracy]
			});

		// add markers to marker layer
		const markersLayer = () =>
			new VectorLayer({
				source: markers(vendorMarkers)
			});

		const extent = markers(vendorMarkers).getExtent();

		await map.getView().fit(extent, map.getSize());
		await map.addLayer(markersLayer(vendorMarkers));
		await map.addOverlay(popupOverlay);
		await map.addEventListener('click', togglePopup);

	} catch (error) {
		console.error('💥 Error in init():', error);
	}
};

init();
